export function newPrintIdempotencyKey(prefix = 'print') {
  const random = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
  return `${prefix}-${random}`;
}

/** Ответа нет (тайм-аут, обрыв Wi-Fi) или 5xx: сервер мог выполнить запрос. */
export function printRequestMayHaveRun(error) {
  const status = Number(error?.response?.status);
  return !error?.response || status >= 500;
}

/**
 * Ключи идемпотентности печати на одно логическое действие (подтверждение заказа,
 * повтор печати, этикетка палеты): повтор после тайм-аута/5xx уходит с тем же ключом —
 * сервер вернёт уже поставленное задание вместо второй этикетки. Новый ключ —
 * после ответа сервера, для другого заказа/принтера или после clear().
 */
export function createPrintActionKeys() {
  const keys = new Map();
  const id = (prefix, scope) => `${prefix}|${scope}`;
  return {
    key(prefix, scope) {
      const slot = id(prefix, scope);
      if (!keys.has(slot)) keys.set(slot, newPrintIdempotencyKey(prefix));
      return keys.get(slot);
    },
    async run(prefix, scope, send) {
      const slot = id(prefix, scope);
      const key = this.key(prefix, scope);
      try {
        const result = await send(key);
        keys.delete(slot);
        return result;
      } catch (error) {
        if (!printRequestMayHaveRun(error)) keys.delete(slot);
        throw error;
      }
    },
    clear() {
      keys.clear();
    },
  };
}

/** Тайм-аут запросов ТСД, которые ставят печать: nginx proxy_read_timeout — 60 с. */
export const TSD_PRINT_TIMEOUT_MS = 45000;

export const PRINT_TIMEOUT_MESSAGE = 'Сервер не ответил вовремя — запрос мог выполниться. '
  + 'Проверьте принтер перед повтором';
